import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccountsService } from '@vendasta/accounts/legacy';
import { BillingUiModule } from '@vendasta/billing-ui';
import { VaFormsModule } from '@vendasta/forms';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { StencilsModule } from '@vendasta/store';
import { IconComponent, VaListModule, VaStatusBannerModule } from '@vendasta/uikit';
import { ActivationSettingsApiService } from '../activation/activation-settings-api.service';
import { ProductOrderFormStoreService } from '../activation/core/product-order-form.store.service';
import { SharedActivationModule } from '../activation/shared/shared-activation.module';
import { UnifiedTOSService } from '../core/tos-unified.service';
import { CampaignService } from '../marketing/campaign.service';
import { UserService, UsersModule } from '../users';
import { AccountAddToListComponent } from './account-add-to-list.component';
import { AccountDeleteComponent } from './account-delete.component';
import { AccountSelectorDialogComponent } from './account-selector-dialog/account-selector-dialog.component';
import { ActiveCampaignChangeEditionDialogComponent } from './active-campaign-change-edition-dialog/ac-change-edition-dialog.component';
import { CampaignDialogItemStoreService } from './campaign-dialog-item-store.service';
import { CampaignDialogItemComponent } from './campaign-dialog-item.component';
import { CampaignDialogStoreService } from './campaign-dialog-store.service';
import { CampaignsDialogComponent } from './campaigns-dialog.component';
import { ChangeEditionDialogComponent } from './change-edition-dialog.component';
import { ChangeEditionDialogService } from './change-edition-dialog.service';
import { ChangePlanDialogModule } from './change-plan-dialog';
import { ChangePlanService } from './change-plan-dialog/change-plan-service';
import { DeactivateDependentProductDialogComponent } from './deactivate-dependent-product-dialog/deactivate-dependent-product-dialog.component';
import { DeactivateDialogComponent } from './deactivate-dialog/deactivate-dialog.component';
import { DeactivateImmediatelyDialogComponent } from './deactivate-immediately-dialog.component';
import { OrderFormSubmissionDialogComponent } from './order-form-submission-dialog.component';
import { RequestSpendChangeDialogComponent } from './request-spend-change-dialog/request-spend-change-dialog.component';
import { MultisiteConsentBoxComponent } from './wsp-multisite-consent-box/wsp-multisite-consent-box.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    VaListModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatIconModule,
    VaFormsModule,
    MatMenuModule,
    MatSelectModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatListModule,
    MatTooltipModule,
    MatChipsModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    MatTabsModule,
    StencilsModule,
    ChangePlanDialogModule,
    MatRadioModule,
    TranslateModule,
    SharedActivationModule,
    MatAutocompleteModule,
    VaStatusBannerModule,
    GalaxyAlertModule,
    GalaxyFormFieldModule,
    GalaxyPipesModule,
    RouterModule,
    GalaxyInputModule,
    UsersModule,
    GalaxyButtonLoadingIndicatorModule,
    BillingUiModule,
    IconComponent,
    MultisiteConsentBoxComponent,
  ],
  exports: [],
  declarations: [
    CampaignsDialogComponent,
    OrderFormSubmissionDialogComponent,
    DeactivateDialogComponent,
    DeactivateDependentProductDialogComponent,
    DeactivateImmediatelyDialogComponent,
    RequestSpendChangeDialogComponent,
    CampaignDialogItemComponent,
    ChangeEditionDialogComponent,
    ActiveCampaignChangeEditionDialogComponent,
    AccountDeleteComponent,
    AccountAddToListComponent,
    AccountSelectorDialogComponent,
  ],
  providers: [
    { provide: 'AccountsServiceInterface', useExisting: AccountsService },
    UserService,
    CampaignService,
    UnifiedTOSService,
    ChangePlanService,
    CampaignDialogStoreService,
    CampaignDialogItemStoreService,
    ChangeEditionDialogService,
    AccountsService,
    ProductOrderFormStoreService,
    ActivationSettingsApiService,
  ],
})
export class AccountsModule {}
